import {
  useGetApiV1AccesscontrolPermissionsSummary,
  useGetApiV1AccesscontrolRoles,
} from '@/shared/api/generated';
import type { RoleControllerPermissionSummaryViewModel } from '@/shared/api/generated/types';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Hook para obter o resumo de permissões de um role específico.
 * Usa o endpoint `/api/v1/accesscontrol/permissions/summary`.
 *
 * @param roleId - ID do role cujas permissões serão carregadas
 * @returns Resumo de permissões por controller, nome do role e estado de loading/error
 *
 * @example
 * ```tsx
 * const { summary, roleName, isLoading } = useRolePermissions(roleId);
 * ```
 */
export function useRolePermissions(roleId: number) {
  const summaryQuery = useGetApiV1AccesscontrolPermissionsSummary({ roleId });
  const rolesQuery = useGetApiV1AccesscontrolRoles();

  const foundRole = rolesQuery.data?.find(r => r.roleId === roleId);
  const rawName = foundRole?.roleName;
  const roleName: string | null = typeof rawName === 'string' ? rawName : null;

  return {
    summary: (summaryQuery.data ?? []) as RoleControllerPermissionSummaryViewModel[],
    roleName,
    isLoading: summaryQuery.isLoading,
    isError: summaryQuery.isError,
  } as const;
}
